import { z } from "zod";

// Badges only: how badges sent to an exhibitor structure reach it. Only the badge issuing
// mutation forwards it; tickets and assignments ignore it.
export const badgeDeliveryModes = ["email", "account"] as const;

export type BadgeDeliveryModeValue = (typeof badgeDeliveryModes)[number];

export const issueTicketsSchema = z
  .object({
    itemId: z.string().min(1, "Vous devez sélectionner un type de billet"),
    tickets: z
      .array(
        z.object({
          visitorId: z.string().nullish(),
          exhibitorId: z.string().nullish(),
          commercialId: z.string().nullish(),
          quantity: z.number(),
        })
      )
      .min(1, "Vous devez émettre au moins un billet"),

    quantityMax: z.number(),
    deliveryMode: z.enum(badgeDeliveryModes).default("email"),
  })
  .refine(
    (data) => {
      const total = data.tickets.reduce(
        (acc, ticket) => acc + ticket.quantity,
        0
      );
      return total <= data.quantityMax;
    },
    {
      message: "Il n'y pas assez de billets.",
      path: ["quantityMax"],
    }
  );

export type IssueTicketsForm = z.infer<typeof issueTicketsSchema>;

// Payload of the mutations that never forward the mode (tickets, assignments).
export type IssueTicketsWithoutDeliveryModeForm = Omit<
  IssueTicketsForm,
  "deliveryMode"
>;

export const defaultIssueTicketsValues: IssueTicketsForm = {
  itemId: "",
  tickets: [],
  quantityMax: Infinity,
  deliveryMode: "email",
};
